import {
  DXRS,
  MonthViewBase,
} from '@lmt/unicorn-shared/app/common/devexpress/Scheduler/dx-react-scheduler';
import React from 'react';

import styles from './Calendar.module.scss';

export const MonthViewDateHeaderCell: React.FC<
  MonthViewBase.DayScaleCellProps
> = (props) => {
  return (
    <DXRS.MonthView.DayScaleCell
      className={styles.monthViewDateHeader}
      {...props}
    />
  );
};
